<template>
  <section class="pt-8 px-8">
    <div>
      <div class="flex flex-col items-center py-2 justify-center gap-y-2">
        <h3 class="text-2xl font-semibold mt-1">
          {{
            parseMoneyAll(
              transactionDetails.amount,
              transactionDetails.currency
            )
          }}
        </h3>
        <p
          class="text-xs text-center font-normal rounded-lg px-1 py-2 capitalize w-24 mt-3 mb-2"
          :class="statusClass(transactionDetails.status)"
        >
          {{ transactionDetails.status }}
        </p>
      </div>
    </div>
    <div class="text-fg-muted">
      <ul>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span>Time & Date</span>
          <span class="">{{ displayTimeDate }}</span>
        </li>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span>Transaction ID</span>
          <span
            >{{ maskID(transactionDetails.id) }}
            <span
              class="cursor-pointer mb-1 ml-2"
              v-clipboard:copy="transactionDetails.id"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 items-center text-sm font-normal border-b py-3.5 lg:py-6"
        >
          <span>Link Name</span>
          <span class="flex items-center gap-x-2">
            <span class="capitalize">{{
              transactionDetails.linkTitle || '--'
            }}</span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span>Fees</span>
          <span> {{ transactionFee || '--' }} </span>
        </li>
        <li
          class="grid grid-cols-2 items-center text-sm font-normal border-b py-3.5 lg:py-6"
        >
          <span>Payment Method</span>
          <span class="flex items-center gap-x-2">
            <span class="capitalize">{{
              formatServerName(transactionDetails.method)
            }}</span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 items-center font-normal text-sm border-b py-3.5 lg:py-6"
        >
          <span>Currency</span>
          <span class="flex items-center gap-x-2">
            <currency-icons
              :currency="getCurrencyCountry(transactionDetails.currency)"
            />
            <span class="capitalize">{{ transactionDetails.currency }}</span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 items-center border-b font-normal text-sm py-3.5 lg:py-6"
        >
          <span>Exchange Rate</span>
          <span class="flex items-center gap-x-2">
            <span class="capitalize">{{
              parseMoneyAll(
                transactionInfo.exchangeRate,
                transactionDetails.currency || '-'
              )
            }}</span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 items-center border-b font-normal text-sm py-3.5 lg:py-6"
        >
          <span>Amount paid</span>
          <span class="flex items-center gap-x-2">
            {{
              parseMoneyAll(
                transactionDetails.amount,
                transactionDetails.currency
              )
            }}
          </span>
        </li>
      </ul>
    </div>
    <div class="text-fg-muted font-normal" v-if="transactionDetails.customer">
      <p class="pt-4 pb-2 border-b">Customer Details</p>
      <div class="flex gap-x-5 p-3 items-center">
        <p>
          <profile-icon />
        </p>
        <div>
          <p class="text-xs font-thin">Customer Name</p>
          <p class="text-sm">
            {{ transactionDetails.customer || '--' }}
          </p>
        </div>
      </div>
      <div class="flex gap-x-5 p-3 items-center">
        <p>
          <phone-icon />
        </p>
        <div v-if="transactionDetails.phoneNumber">
          <p class="text-xs font-thin">Phone Number</p>
          <p class="text-sm">
            {{ transactionDetails.phoneNumber || '--' }}
          </p>
        </div>
      </div>
      <div class="flex gap-x-5 p-3 items-center">
        <p>
          <email-icon />
        </p>
        <div>
          <p class="text-xs font-thin">Email</p>
          <p class="text-sm">
            {{ transactionDetails.email || '--' }}
          </p>
        </div>
      </div>
      <div
        v-if="transactionDetails.address"
        class="flex gap-x-5 p-3 items-center"
      >
        <adress-icon />
        <div>
          <p class="text-xs font-thin">Address</p>
          <p class="text-sm">
            {{ transactionDetails.address || '--' }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  ParseMoneyAll,
  GetCurrencyCountry,
  MaskWalletAddressTwo,
  FormatServerName,
  StatusClass
} from '@/utils/helpers.js'
import tooltipDateContent from '@/mixins/app.js'

export default {
  mixins: [tooltipDateContent],
  props: {
    transactionDetails: {
      type: Object,
      default: () => {}
    },
    rateIncreased: {
      type: Boolean,
      default: () => false,
      required: true
    }
  },
  data () {
    return {
      showWithdrawalDetails: false
    }
  },
  methods: {
    statusClass (status) {
      return StatusClass(status)
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    handleClose () {
      this.$emit('closeDrawer')
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    ProfileIcon: () => import('@/assets/v2/icons/ProfileIcon1.vue'),
    EmailIcon: () => import('@/assets/v2/icons/EmailIcon1.vue'),
    PhoneIcon: () => import('@/assets/v2/icons/PhoneIcon1.vue'),
    AdressIcon: () => import('@/assets/v2/icons/AdressIcon.vue')
  },
  computed: {
    transactionFee () {
      return (
        this.transactionDetails.transferInstruction?.fee?.feeFlat ||
        '% ' + this.transactionDetails.transferInstruction?.fee?.feePercent
      )
    },
    transactionInfo () {
      return this.transactionDetails.transferInstruction
    },
    displayTimeDate () {
      return this.tooltipDateContent(this.transactionDetails.createdAt)
    }
  }
}
</script>
